import styled from 'styled-components'

import { Flex } from '@/atoms/layout'

export const AppWrapper = styled(Flex)`
  overflow-y: auto;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
  align-items: center;
  background: ${({ theme }) => `linear-gradient(to right, ${theme.colors.white} 50%, ${theme.colors.violet} 50%)`};

  ${({ theme }) => theme.mediaQueries.notMobile} {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.greyLight};
      border: 1px solid ${({ theme }) => theme.colors.bgDark};
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.bgDark};
    }
  }

  ${({ theme }) => theme.mediaQueries.mobile} {
    background: ${({ theme }) => theme.colors.white};
  }
`

export const ContentWrapper = styled.main`
  position: relative;
  max-width: 1280px;
  min-width: 300px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => `linear-gradient(to right, ${theme.colors.white} 60%, ${theme.colors.violet} 40%)`};
  padding: ${({ theme }) => `0 ${theme.space.S40}`};

  ${({ theme }) => theme.mediaQueries.mobile} {
    background: ${({ theme }) => theme.colors.white};
  }
`
export const HeaderWrapper = styled.header`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  height: 80px;
`
